import { makeApiTypes } from 'sidecar-utility-library'

export const types = {
  // Expenses
  INITIAL_REQUEST_SUCCESS: 'expense/INITIAL_REQUEST_SUCCESS',
  ...makeApiTypes('FETCH_SEARCH_FILTERS', 'expense'),
  ...makeApiTypes('FETCH_EXPENSES', 'expense'),
  ...makeApiTypes('FETCH_UPLOADABLE_EXPENSES', 'expense'),
  ...makeApiTypes('SET_MEMBER_AND_FETCH_UPLOADABLE_EXPENSES', 'expense'),
  ...makeApiTypes('FETCH_EXPENSE_DETAILS', 'expense'),
  ...makeApiTypes('FETCH_EXPLANATION_OF_BENEFITS', 'expense'),
  ...makeApiTypes('FETCH_RECEIPTS', 'expense'),
  ...makeApiTypes('FETCH_CARE_SERVICES', 'expense'),
  ...makeApiTypes('FETCH_EXPENSE_SUGGESTIONS', 'expense'),
  ...makeApiTypes('FETCH_EXPENSE_CHART', 'expense'),
  ...makeApiTypes('FETCH_OUTSTANDING_EXPENSES', 'expense'),
  ...makeApiTypes('FETCH_OUTSTANDING_EXPENSE_BALANCE', 'expense'),
  ...makeApiTypes('FETCH_BENEFIT_CARD_CONTROLS', 'expense'),
  SET_FILTER: 'expense/SET_FILTER',
  RESET_EXPENSE_SEARCH: 'expense/RESET_EXPENSE_SEARCH',
  CLEAR_WORKING_EXPENSE: 'expense/CLEAR_WORKING_EXPENSE',
  CLEAR_ACTIVE_EXPENSE: 'expense/CLEAR_ACTIVE_EXPENSE',
  CLEAR_WORKING_EXPENSE_ERROR: 'expense/CLEAR_WORKING_EXPENSE_ERROR',
  CLEAR_NEW_EXPENSE: 'expense/CLEAR_NEW_EXPENSE',
  SET_NEW_EXPENSE_MEMBER: 'expense/SET_NEW_EXPENSE_MEMBER',
  SET_NEW_ACTIVE_EXPENSE: 'expense/SET_NEW_ACTIVE_EXPENSE',
  NEW_RECEIPT_UPLOAD: 'expense/NEW_RECEIPT_UPLOAD',
  ...makeApiTypes('CREATE_EXPENSE', 'expense'),
  ...makeApiTypes('CREATE_EXPENSE_WITHOUT_RECEIPT', 'expense'),
  ...makeApiTypes('FETCH_DASHBOARD_EXPENSES', 'expense'),

  // Payments
  ...makeApiTypes('MAKE_PAYMENT', 'payment'),
  ...makeApiTypes('FETCH_MANUAL_PAYMENT_BREAKDOWN', 'payment'),
  ...makeApiTypes('CREATE_EXPENSE_PAYMENT', 'payment'),
  CLEAR_MAKE_PAYMENT_ERROR: 'payment/CLEAR_MAKE_PAYMENT_ERROR',
  CLEAR_BENEFIT_CARD_CONTROLS: 'expense/CLEAR_BENEFIT_CARD_CONTROLS',
  CLEAR_MANUAL_PAYMENT_BREAKDOWN: 'payment/CLEAR_MANUAL_PAYMENT_BREAKDOWN',

  //Refunds
  ...makeApiTypes('FETCH_REFUND_DETAILS', 'refund'),
  ...makeApiTypes('ASSOCIATE_EXPENSE', 'refund'),

  // Receipts
  ...makeApiTypes('FETCH_RECEIPT_DETAILS', 'receipt'),
  ...makeApiTypes('UPLOAD_RECEIPT', 'receipt'),
  ...makeApiTypes('DELETE_RECEIPT', 'receipt'),
  ...makeApiTypes('EDIT_RECEIPT', 'receipt'),
  ...makeApiTypes('SUBMIT_RECEIPTS', 'receipt'),
  ...makeApiTypes('EVALUATE_RECEIPT', 'receipt'),
  UPDATE_UPLOAD_RECEIPT_WARNINGS: 'receipt/UPDATE_UPLOAD_RECEIPT_WARNINGS',
  CLEAR_UPLOAD_RECEIPT_WARNING: 'receipt/CLEAR_UPLOAD_RECEIPT_WARNING',
  CLEAR_UPLOAD_RECEIPT_WARNINGS: 'receipt/CLEAR_UPLOAD_RECEIPT_WARNINGS',
  CLEAR_RECEIPT_ERRORS: 'receipt/CLEAR_RECEIPT_ERRORS',

  // Build A Bill
  ...makeApiTypes('SAVE_BUILD_A_BILL_FORM', 'buildABill'),
  ...makeApiTypes('FETCH_BUILD_A_BILL_FORM', 'buildABill'),
  CLEAR_BUILD_A_BILL_ERROR: 'buildABill/CLEAR_BUILD_A_BILL_ERROR',
  CLEAR_BUILD_A_BILL_DATA: 'buildABill/CLEAR_BUILD_A_BILL_DATA',

  // Payment Questions
  ...makeApiTypes('SAVE_PAYMENT_QUESTIONS', 'paymentQuestions'),
  ...makeApiTypes('FETCH_PAYMENT_QUESTIONS', 'paymentQuestions'),
  CLEAR_PAYMENT_QUESTIONS_ERROR:
    'paymentQuestions/CLEAR_PAYMENT_QUESTIONS_ERROR',
  CLEAR_PAYMENT_QUESTIONS_DATA: 'paymentQuestions/CLEAR_PAYMENT_QUESTIONS_DATA',

  // Clinical Notes
  ...makeApiTypes('SAVE_CLINICAL_NOTES_FORM', 'clinicalNotes'),
  ...makeApiTypes('FETCH_CLINICAL_NOTES_FORM', 'clinicalNotes'),
  CLEAR_CLINICAL_NOTES_ERROR: 'clinicalNotes/CLEAR_CLINICAL_NOTES_ERROR',
  CLEAR_CLINICAL_NOTES_DATA: 'clinicalNotes/CLEAR_CLINICAL_NOTES_DATA',

  // AI Follow-up Questions
  ...makeApiTypes('FETCH_AI_FOLLOW_UP_QUESTIONS', 'aiFollowUpQuestions'),
  ...makeApiTypes('FETCH_AI_FOLLOW_UP_ANSWERS', 'aiFollowUpAnswers'),
  ...makeApiTypes('SAVE_AI_FOLLOW_UP_ANSWERS', 'aiFollowUpQuestions'),
  CLEAR_AI_FOLLOW_UP_QUESTIONS_ERROR:
    'aiFollowUpQuestions/CLEAR_AI_FOLLOW_UP_QUESTIONS_ERROR',
  CLEAR_AI_FOLLOW_UP_QUESTIONS_DATA:
    'aiFollowUpQuestions/CLEAR_AI_FOLLOW_UP_QUESTIONS_DATA',
  CLEAR_AI_FOLLOW_UP_ANSWERS_DATA:
    'aiFollowUpAnswers/CLEAR_AI_FOLLOW_UP_ANSWERS_DATA',
  SET_AI_FOLLOW_UP_QUESTIONS_VISIBILITY:
    'aiFollowUpQuestions/SET_AI_FOLLOW_UP_QUESTIONS_VISIBILITY',

  // Pharmacy Prescription Form (Fix a Bill)
  ...makeApiTypes(
    'FETCH_PHARMACY_PRESCRIPTION_FORM',
    'pharmacyPrescriptionForm',
  ),
  ...makeApiTypes(
    'SUBMIT_PHARMACY_PRESCRIPTION_FORM',
    'pharmacyPrescriptionForm',
  ),
  ...makeApiTypes(
    'FETCH_PHARMACY_PRESCRIPTION_SUMMARY',
    'pharmacyPrescriptionForm',
  ),
  ...makeApiTypes('FETCH_NDC_SUGGESTIONS', 'pharmacyPrescriptionForm'),
  CLEAR_PHARMACY_PRESCRIPTION_FORM_ERROR:
    'pharmacyPrescriptionForm/CLEAR_PHARMACY_PRESCRIPTION_FORM_ERROR',
  CLEAR_PHARMACY_PRESCRIPTION_FORM_DATA:
    'pharmacyPrescriptionForm/CLEAR_PHARMACY_PRESCRIPTION_FORM_DATA',

  // Benefit Card
  // This set of endpoints should hopefully replace the other benefit card
  // ones that are scattered around the stores.
  ...makeApiTypes('FETCH_CARD_INFO', 'benefitCard'),

  // Recurring Expense
  ...makeApiTypes('SUBMIT_RECURRING_EXPENSE', 'recurringExpense'),
  ...makeApiTypes('FETCH_RECURRING_EXPENSE_DATA', 'recurringExpense'),
  CLEAR_RECURRING_EXPENSE_DATA: 'recurringExpense/CLEAR_RECURRING_EXPENSE_DATA',

  // Recurring Expense Form
  ...makeApiTypes('SAVE_RECURRING_EXPENSE_FORM', 'recurringExpenseForm'),
  ...makeApiTypes('FETCH_RECURRING_EXPENSE_FORM', 'recurringExpenseForm'),
  CLEAR_RECURRING_EXPENSE_FORM_ERROR:
    'recurringExpenseForm/CLEAR_RECURRING_EXPENSE_FORM_ERROR',
  CLEAR_RECURRING_EXPENSE_FORM_DATA:
    'recurringExpenseForm/CLEAR_RECURRING_EXPENSE_FORM_DATA',

  //  Eob Docs
  ...makeApiTypes('FETCH_EOB_DOCS', 'expense'),
  ...makeApiTypes('FETCH_EXPLAIN_MEMBER_RESPONSIBILITY', 'expense'),
  ...makeApiTypes('CREATE_EXPENSE_AGENT_FEEDBACK', 'expense'),
  CLEAR_EOB_DOCS_ERRORS: 'expense/CLEAR_EOB_DOCS_ERRORS',

  // Swipe Linking (G20-3009 PR-2). `linkExpenses` PUTs a link between a source
  // expense and a target (typically a swipe). `fetchLinkableCandidates` loads
  // the BE-computed candidate list for a source expense; the response is stored
  // under the dedicated `linkableCandidates` slice below.
  ...makeApiTypes('LINK_EXPENSES', 'expense'),
  ...makeApiTypes('FETCH_LINKABLE_CANDIDATES', 'expense'),
  // Optimistic patch fired after linkExpenses succeeds so the linked-expense
  // card renders immediately, without waiting on the PAYMENT_INFO refetch.
  PATCH_PAYMENT_QUESTIONS_LINKED_EXPENSE:
    'expense/PATCH_PAYMENT_QUESTIONS_LINKED_EXPENSE',
  // Resets the `linkableCandidates` slice — dispatched when a modal that
  // fetched candidates closes so a stale list doesn't linger for the next
  // consumer.
  CLEAR_LINKABLE_CANDIDATES: 'expense/CLEAR_LINKABLE_CANDIDATES',
}

export const initialState = {
  isInitialized: false,
  searchFilters: {
    busy: false,
    error: '',
    filters: {},
  },
  newExpense: {
    expenseResults: [],
    workingMember: null,
    activeExpense: null,
    uploadingNewReceipt: false,
    busy: false,
    error: null,
  },
  workingExpense: {
    busy: false,
    entity: {},
    error: null,
  },
  activeExpense: {
    busy: false,
    entity: {},
    error: null,
  },
  searchResults: {
    busy: false,
    page: null,
    size: 25,
    endOfResults: false,
    entries: [],
    error: '',
  },
  searchBarSuggestions: {
    busy: false,
    page: null,
    size: 5,
    isLastPageReached: false,
    entries: [],
  },
  receipts: {
    busy: false,
    evaluatingReceiptsBusy: false, // New busy flag for evaluating receipts
    error: '',
    detail: {},
    warnings: {},
  },
  buildABill: {
    busy: false,
    entity: {},
    error: null,
  },
  paymentQuestions: {
    busy: false,
    entity: {},
    error: null,
  },
  clinicalNotes: {
    busy: false,
    entity: {},
    error: null,
  },
  aiFollowUpQuestions: {
    busy: false,
    entity: {},
    error: null,
    visible: false,
    savingAnswers: false,
    saveError: null,
  },
  aiFollowUpAnswers: {
    busy: false,
    entity: null,
    error: null,
  },
  outstandingExpenses: {
    busy: false,
    error: null,
    entities: [],
  },
  benefitCardControls: {
    busy: false,
    error: null,
    entities: [],
  },
  activeExpensePayment: {
    paymentSubmission: {
      busy: false,
      error: null,
    },
    breakdown: {
      busy: false,
      error: null,
      entity: {},
    },
  },
  payments: {
    busy: false,
    error: '',
  },
  refunds: {
    refundInfo: {},
    expenses: [],
    busy: false,
    error: '',
  },
  scrubs: {
    busy: false,
    entities: [],
    error: '',
    expenseUuid: '',
  },
  dashboardExpenses: {
    busy: false,
    error: null,
    entities: [],
  },
  eobDocs: {
    busy: false,
    error: null,
    entity: {},
  },
  // explainExpense and expenseAgentFeedback are used in the
  // ExpenseExplanation component to show the agent's explanation.
  // This is a prototype feature introduced in PR 3279.
  explainExpense: {
    busy: false,
    entity: null,
    error: null,
  },
  expenseAgentFeedback: {
    busy: false,
    error: null,
  },
  // Recurring expense data (care services + provider info) - separate from activeExpense
  recurringExpenseCareServices: {
    busy: false,
    entity: null,
    error: null,
  },
  // Recurring expense submission state
  recurringExpense: {
    busy: false,
    error: null,
  },
  // Recurring expense form state (expense-form endpoint)
  recurringExpenseForm: {
    busy: false,
    entity: {},
    error: null,
  },
  // G20-3009 PR-2: BE-driven swipe candidates. Consumers should dispatch
  // `fetchLinkableCandidates(sourceExpenseUuid)` to populate this slice and
  // read `entity.candidates` (or `busy`/`error`) directly. The selector-based
  // `selectLinkableCandidates` path still reads from the local expense store
  // for callsites that prefer client-side derivation.
  linkableCandidates: {
    busy: false,
    entity: { candidates: [] },
    error: null,
    sourceExpenseUuid: null,
  },
  // Pharmacy prescription form (Fix a Bill feature)
  pharmacyPrescriptionForm: {
    busy: false,
    entity: {},
    error: null,
    submitting: false,
    submitError: null,
    // NDC suggestions
    ndcSuggestions: {
      busy: false,
      entities: [],
      error: null,
    },
  },
}
